export class Constants {
    public static tipoLicenza = {
        ENT: "Enterprise",
        PRO: "Professional",
        STA: "Starter"
    };
}